// extracted by mini-css-extract-plugin
export default {"compressor":"_94ymoRP7rzEW8N5zdJvseQ==","headerAndMain":"dQ2XX1NhoKOGLy+qoAZ3yQ=="};